import { autoinject, transient } from "aurelia-dependency-injection";
import { BaseRedMarblePlugin } from "./base-red-marble";
import { PscService } from "../../../../../../../../services/psc/psc.service";
import { UserClaimsService } from "../../../../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../../../../constants/authentication/claims";
import { Router } from "aurelia-router";
import { RightShipQiRouterConstants } from "../../../../../../../../configuration/rightshipqi-router.constants";
import { Md5 } from "../../../../../../../../utilities/md5";
import { Reflection } from "../../../../../../../../utilities/reflection";
import { computedFrom } from "aurelia-binding";

@autoinject
@transient()
export class Psc extends BaseRedMarblePlugin {

    canAddPsc: boolean;
    constructor(private pscService: PscService, private userClaimsService: UserClaimsService, private router: Router) {
        super();
        this.canAddPsc = this.userClaimsService.hasPermission(Claims.CanAddPSC);
    }
    
    @computedFrom(Reflection.getPropertyPath<Psc>(z => z.data),
        Reflection.getPropertyPath<Psc>(z => z.data.data),
        Reflection.getPropertyPath<Psc>(z => z.data.data.inspections),
        Reflection.getPropertyPath<Psc>(z => z.data.data.inspections.length),
        Reflection.getPropertyPath<Psc>(z => z.rsData))
    get pscs() {
        if (!this.data || !this.data.data || this.data.data.inspections.length == 0)
            return null;

        const ignored = this.rsData ? this.rsData : [];

        for (const p of this.data.data.inspections)
            p.id = Md5.hashStr(this.getPscString(p));

        return this.data.data.inspections.filter(x => ignored.indexOf(x.id) == -1);
    }

    getPscString(psc) {
        let str = "";

        str += `Date_${psc.dateTime ? psc.dateTime : ''}_`;
        str += `Authority_${psc.authority ? psc.authority : ''}_`;
        str += `Port_${psc.port ? psc.port : ''}_`;
        str += `Country_${psc.country ? psc.country : ''}_`;
        str += `Type_${psc.type ? psc.type : ''}_`;
        str += `Detained_${psc.detained ? 'true' : 'false'}_`;
        str += `Deficiencies_${psc.deficiencies ? psc.deficiencies : 0}_`;

        return str;
    }

    createPsc(item: { id: string, detained: boolean, dateTime: string, authority: string, country: string, port: string, deficiencies: number }) {
        if (this.canAddPsc) {
            window.open(this.router.generate(RightShipQiRouterConstants.RouteNames.AddPsc,
                {
                    id: 0,
                    vesselId: this.vet.vesselId,
                    internationalMaritimeOrganizationNumber:
                        this.vet.internationalMaritimeOrganizationNumber ? this.vet.internationalMaritimeOrganizationNumber : '0',
                    vesselName: this.vet.vesselName.replace(".", ""),
                    isDetained: item.detained == true,
                    date: item.dateTime,
                    authority: item.authority,
                    port: item.port,
                    country: item.country,
                    deficiencies: item.deficiencies
                }), '_blank');
        }
    }

    async removePsc(item: { id: string, isRemovingPsc: boolean }) {
        item.isRemovingPsc = true;
        try {
            this.vetTask.rightshipPayload = await this.pscService.removePsc(this.vet.vesselId, item.id);
            this.loadData();
        } catch (e) {
            console.error("error removing psc", e);
        }
        finally {
            item.isRemovingPsc = false;
        }
    }

    // {
    //     "correlationId": "37a217b3-a56e-4f7e-b0a0-d2c6f0a3dc81",
    //     "fallbackString": "A total of 1 inspections were found:\r\n\t2019-09-26 by the authority Paris MoU at the port Amsterdam.\r\n",
    //     "data": {
    //       "inspections": [
    //         {
    //           "id": "5358721",
    //           "dateTime": "2019-09-26T00:00:00Z",
    //           "authority": "Paris MoU",
    //           "port": "Amsterdam",
    //           "country": "Netherlands",
    //           "type": "Follow-Up Inspection",
    //           "detained": false,
    //           "deficiencies": 8,
    //           "deficiencyDetails": [],
    //           "sources": [
    //             "Paris MoU",
    //             "Equasis"
    //           ]
    //         }
    //       ]
    //     }
    //   }

}